import { Outlet } from "react-router-dom";
import { Header } from "components/header";

export default function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <main className="flex flex-1 flex-col">
        <div className="container mx-auto flex w-full flex-1 flex-col px-4 sm:px-6 lg:px-12 xl:px-16">
          <Outlet />
        </div>
      </main>
      <footer className="border-t py-6">
        <div className="container mx-auto px-4 sm:px-6 lg:px-12 xl:px-16">
          <p className="text-center text-xs text-muted-foreground">
            Investments are risky, illiquid and may result in total loss of capital.
          </p>
        </div>
      </footer>
    </div>
  );
}
